<div class="page__content">
  <div class="content__inner">
    <div *ngIf="currentUser; else loggedOut" class="profile-stack">

      <div class="fb-card">
        <div class="fb-card__body profile-head">
          <div class="profile-head__user">
            <div class="profile-avatar">
              <p>{{getFirstLetter(this.currentUser.nombre)}}{{getFirstLetter(this.currentUser.apellido1)}}</p>
            </div>
            <div class="profile-head__info">
              <b>{{this.currentUser.nombre}} {{this.currentUser.apellido1}}</b>
              <p>{{this.currentUser.email}}</p>
              <form [formGroup]="form2" (click)="openDeleteDialog()" *ngIf="this.currentUser.email != null">
                <button type="button" class="fb-btn btn-danger-ghost">{{ 'PROFILE.DEACTIVATE' | translate }}</button>
              </form>
            </div>
          </div>

          <div class="profile-head__2fa" *ngIf="currentUser.email">
            <div *ngIf="!tfActivated && !isShown && !loading" class="profile-2fa-active">
              <p class="profile-2fa-active__label">{{ 'PROFILE.TFA_LABEL' | translate }}</p>
              <div class="profile-2fa-active__row">
                <span class="profile-2fa-badge profile-2fa-badge--off">{{ 'PROFILE.TFA_OFF' | translate }}</span>
                <form [formGroup]="form2" (ngSubmit)="pedirQR()" class="profile-2fa-active__form">
                  <button type="submit" class="fb-btn fb-btn--primary">{{ 'PROFILE.ACTIVATE_TFA' | translate }}</button>
                </form>
              </div>
            </div>

            <div *ngIf="loading" class="profile-spinner">
              <div class="spinner-border" role="status"><span class="sr-only"></span></div>
              <span>{{ 'COMMON.LOADING' | translate }}</span>
            </div>

            <div *ngIf="!tfActivated && isShown && !loading" class="profile-qr">
              <button type="button" class="profile-qr__close" (click)="cerrarActivacion2FA()"
                [attr.aria-label]="'PROFILE.TFA_CLOSE' | translate" [attr.title]="'PROFILE.TFA_CLOSE' | translate">×</button>
              <p class="profile-qr__intro">{{ 'PROFILE.SCAN_QR' | translate }}</p>
              <div class="profile-qr__code">
                <img *ngIf="qr?.secretURL" [src]="qr.secretURL" alt="QR Authenticator" />
              </div>
              <form [formGroup]="form3" (ngSubmit)="guardarQR()" *ngIf="qr?.secret" class="profile-qr__form">
                <label class="fb-label" for="profile-totp">{{ 'PROFILE.CODE_PH' | translate }}<span class="fb-req">*</span></label>
                <input id="profile-totp" type="text" autocomplete="one-time-code" formControlName="totpkey"
                  class="fb-input profile-qr__otp" placeholder="000000" maxlength="6"
                  [ngClass]="{'ng-invalid ng-touched': errorQR}" />
                <button type="submit" class="fb-btn fb-btn--primary">{{ 'PROFILE.ACTIVATE_TFA' | translate }}</button>
              </form>
              <div *ngIf="errorQR" class="profile-qr__alert">
                <p>{{ 'PROFILE.TFA_ERROR' | translate }}</p>
              </div>
            </div>

            <div *ngIf="tfActivated" class="profile-2fa-active">
              <p class="profile-2fa-active__label">{{ 'PROFILE.TFA_LABEL' | translate }}</p>
              <div class="profile-2fa-active__row">
                <span class="profile-2fa-badge profile-2fa-badge--on">{{ 'PROFILE.TFA_ON' | translate }}</span>
                <form [formGroup]="form3" (ngSubmit)="quitarQR()" *ngIf="!vpnActivaMandatory" class="profile-2fa-active__form">
                  <button type="submit" class="fb-btn fb-btn--ghost">{{ 'PROFILE.DEACTIVATE_TFA' | translate }}</button>
                </form>
              </div>
              <p *ngIf="vpnActivaMandatory" class="profile-2fa-active__hint">{{ 'PROFILE.TFA_MANDATORY' | translate }}</p>
            </div>
          </div>
        </div>
      </div>

      <form *ngIf="!isSuccessful" name="form" (ngSubmit)="onSubmit()" [formGroup]="form" novalidate class="profile-stack">

        <div class="fb-card" *ngIf="this.currentUser.tipopersona.id == '2'">
          <div class="fb-card__header">{{ 'PROFILE.COMPANY_DATA' | translate }}</div>
          <div class="fb-card__body">
            <div class="fb-row">
              <div class="fb-col fb-col--6">
                <label class="fb-label">{{ 'PROFILE.COMPANY_NAME' | translate }}<span class="fb-req">*</span></label>
                <input autocomplete="off" type="text" class="fb-input" name="nombre" [formControlName]="'nombre'"
                       minlength="3" maxlength="20" [attr.disabled]="'true'"
                       [ngClass]="{'is-invalid': submitted && this.form.controls['nombre'].errors}" />
              </div>
              <div class="fb-col fb-col--6">
                <label class="fb-label">{{ 'PROFILE.PERSON_TYPE' | translate }}<span class="fb-req">*</span></label>
                <select class="fb-input fb-select" [formControlName]="'tipo_persona'" [attr.disabled]="'true'"
                        [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_persona'].errors}">
                  <option *ngFor="let tipopersona of TPersonas" [value]="tipopersona.id">{{ tipopersona.nombre }}</option>
                </select>
              </div>
              <div class="fb-col fb-col--6">
                <label class="fb-label">{{ 'PROFILE.DOC_TYPE' | translate }}<span class="fb-req">*</span></label>
                <select class="fb-input fb-select" [formControlName]="'tipo_documento'" [attr.disabled]="'true'"
                        [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_documento'].errors}">
                  <option *ngFor="let tipodocumento of TDocumentos" [value]="tipodocumento.id">{{ tipodocumento.nombre }}</option>
                </select>
              </div>
              <div class="fb-col fb-col--6">
                <label class="fb-label">{{ 'PROFILE.DOC_NUMBER' | translate }}<span class="fb-req">*</span></label>
                <input autocomplete="off" name="numero_documento" class="fb-input"
                       [formControlName]="'numero_documento'" [attr.disabled]="'true'"
                       [ngClass]="{'is-invalid': submitted && this.form.controls['numero_documento'].errors}" />
              </div>
            </div>
          </div>
        </div>

        <div class="fb-card" *ngIf="this.currentUser.tipopersona.id != '2' || this.currentUser.usuarioRepresenta?.numeroDocumento">
          <div class="fb-card__header">{{ currentUser.tipopersona.id == '2' ? ('PROFILE.RESPONSIBLE_DATA' | translate) : ('PROFILE.PERSONAL_DATA' | translate) }}</div>
          <div class="fb-card__body">
            <div class="fb-row">
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.FIRST_NAME' | translate }}<span class="fb-req">*</span></label>
                <input autocomplete="off" type="text" class="fb-input" name="nombre"
                       [formControlName]="this.currentUser.tipopersona.id == '2' ? 'nombre_responsable' : 'nombre'"
                       minlength="3" maxlength="20" [attr.disabled]="'true'"
                       [ngClass]="{'is-invalid': submitted && this.form.controls['nombre'].errors}" />
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.SURNAME1' | translate }}<span class="fb-req">*</span></label>
                <input autocomplete="off" type="text" class="fb-input" name="apellido1"
                       [formControlName]="this.currentUser.tipopersona.id == '2' ? 'apellido1_responsable' : 'apellido1'"
                       minlength="3" maxlength="20" [attr.disabled]="'true'"
                       [ngClass]="{'is-invalid': submitted && this.form.controls['apellido1'].errors}" />
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.SURNAME2' | translate }}</label>
                <input autocomplete="off" type="text" class="fb-input" name="apellido2"
                       [formControlName]="this.currentUser.tipopersona.id == '2' ? 'apellido2_responsable' : 'apellido2'"
                       minlength="3" maxlength="20" [attr.disabled]="'true'"
                       [ngClass]="{'is-invalid': submitted && this.form.controls['apellido2'].errors}" />
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.PERSON_TYPE' | translate }}<span class="fb-req">*</span></label>
                <select class="fb-input fb-select"
                        [formControlName]="this.currentUser.tipopersona.id == '2' ? 'tipo_persona_responsable' : 'tipo_persona'"
                        [attr.disabled]="'true'"
                        [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_persona'].errors}">
                  <option *ngFor="let tipopersona of TPersonas" [value]="tipopersona.id">{{ tipopersona.nombre }}</option>
                </select>
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.DOC_TYPE' | translate }}<span class="fb-req">*</span></label>
                <select class="fb-input fb-select"
                        [formControlName]="this.currentUser.tipopersona.id == '2' ? 'tipo_documento_responsable' : 'tipo_documento'"
                        [attr.disabled]="'true'"
                        [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_documento'].errors}">
                  <option *ngFor="let tipodocumento of TDocumentos" [value]="tipodocumento.id">{{ tipodocumento.nombre }}</option>
                </select>
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.DOC_NUMBER' | translate }}<span class="fb-req">*</span></label>
                <input autocomplete="off" name="numero_documento" class="fb-input"
                       [formControlName]="this.currentUser.tipopersona.id == '2' ? 'numero_documento_responsable' : 'numero_documento'"
                       [attr.disabled]="'true'"
                       [ngClass]="{'is-invalid': submitted && this.form.controls['numero_documento'].errors}" />
              </div>
            </div>
          </div>
        </div>

        <div class="fb-card">
          <div class="fb-card__header">{{ 'PROFILE.CONTACT_DATA' | translate }}</div>
          <div class="fb-card__body">
            <div class="fb-row">
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.STREET_TYPE' | translate }}<span class="fb-req">*</span></label>
                <select formControlName="tipo_via" class="fb-input fb-select"
                        [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_via'].errors}">
                  <option *ngFor="let vias of TVias" [value]="vias.id">{{ vias.tipovianormalizado }}</option>
                </select>
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.ADDRESS' | translate }}<span class="fb-req">*</span></label>
                <input autocomplete="off" type="text" formControlName="nombre_via" class="fb-input"
                       [ngClass]="{'is-invalid': submitted && this.form.controls['nombre_via'].errors}" />
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.STREET_NUMBER' | translate }}<span class="fb-req">*</span></label>
                <input autocomplete="off" type="text" formControlName="numero_via" class="fb-input"
                       [ngClass]="{'is-invalid': submitted && this.form.controls['numero_via'].errors}" />
              </div>

              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.BLOCK' | translate }}</label>
                <input autocomplete="off" type="text" formControlName="bloque" class="fb-input" />
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.STAIR' | translate }}</label>
                <input autocomplete="off" type="text" formControlName="escalera" class="fb-input" />
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.FLOOR' | translate }}</label>
                <input autocomplete="off" type="text" formControlName="piso" class="fb-input" />
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.DOOR' | translate }}</label>
                <input autocomplete="off" type="text" formControlName="puerta" class="fb-input" />
              </div>

              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.COUNTRY' | translate }}<span class="fb-req">*</span></label>
                <select formControlName="pais" class="fb-input fb-select"
                        [ngClass]="{'is-invalid': submitted && this.form.controls['pais'].errors}">
                  <option *ngFor="let _pais of TPais" [value]="_pais.id">{{ _pais.nombre }}</option>
                </select>
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.REGION' | translate }}<span class="fb-req">*</span></label>
                <select formControlName="ccaa" class="fb-input fb-select" (change)="onChangeProvincia($event)"
                        [ngClass]="{'is-invalid': submitted && this.form.controls['ccaa'].errors}">
                  <option *ngFor="let ccaa of TComunidades" [value]="ccaa.id">{{ ccaa.nombre }}</option>
                </select>
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.PROVINCE' | translate }}<span class="fb-req">*</span></label>
                <select formControlName="provincia" class="fb-input fb-select" (change)="onChangeMunicipio($event)"
                        [ngClass]="{'is-invalid': submitted && this.form.controls['provincia'].errors}">
                  <option *ngFor="let provincia of TProvincias" [value]="provincia.id">{{ provincia.nombre }}</option>
                </select>
              </div>

              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.MUNICIPALITY' | translate }}<span class="fb-req">*</span></label>
                <select formControlName="municipio" class="fb-input fb-select"
                        [ngClass]="{'is-invalid': submitted && this.form.controls['municipio'].errors}">
                  <option *ngFor="let municipio of TMunicipios" [value]="municipio.municipioPK['municipio_id']">{{ municipio.nombre }}</option>
                </select>
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.POSTAL_CODE' | translate }}<span class="fb-req">*</span></label>
                <input autocomplete="off" type="text" mask="9{5}" formControlName="codigo_postal" class="fb-input"
                       [ngClass]="{'is-invalid': submitted && this.form.controls['codigo_postal'].errors}" />
              </div>
              <div class="fb-col fb-col--4">
                <label class="fb-label">{{ 'PROFILE.MOBILE' | translate }}<span class="fb-req">*</span></label>
                <input autocomplete="off" type="text" class="fb-input" name="telefono" formControlName="telefono"
                       [ngClass]="{'is-invalid': submitted && this.form.controls['telefono'].errors}" />
              </div>
            </div>

            <div class="email-highlight" *ngIf="this.currentUser.email != null">
              <div class="fb-row">
                <div class="fb-col fb-col--12">
                  <label class="fb-label">{{ 'COMMON.EMAIL' | translate }}<span class="fb-req">*</span></label>
                  <input autocomplete="off" type="email" name="email" class="fb-input" formControlName="email"
                         placeholder="{{this.currentUser.email}}"
                         [ngClass]="{'is-invalid': submitted && this.form.controls['email'].errors}" />
                </div>
              </div>
            </div>

            <div class="email-highlight" *ngIf="this.currentUser.email == null">
              <div class="fb-row">
                <div class="fb-col fb-col--4">
                  <label class="fb-label">{{ 'COMMON.EMAIL' | translate }}<span class="fb-req">*</span></label>
                  <input autocomplete="off" type="email" name="email" class="fb-input" formControlName="email"
                         [ngClass]="{'is-invalid': submitted && this.form.controls['email'].errors}" />
                </div>
                <div class="fb-col fb-col--4">
                  <label class="fb-label">{{ 'COMMON.PASSWORD' | translate }}<span class="fb-req">*</span></label>
                  <input autocomplete="off" type="password" class="fb-input" name="password" formControlName="password" minlength="6"
                         [ngClass]="{'is-invalid': submitted && this.form.controls['password'].errors}" />
                </div>
                <div class="fb-col fb-col--4">
                  <label class="fb-label">{{ 'PROFILE.CONFIRM_PASSWORD' | translate }}<span class="fb-req">*</span></label>
                  <input autocomplete="off" type="password" class="fb-input" name="password_confirmacion" formControlName="password_confirmacion" minlength="6"
                         [ngClass]="{'is-invalid': submitted && this.form.controls['password_confirmacion'].errors}" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <p class="data_required">{{ 'PROFILE.REQUIRED_HINT' | translate }}</p>
        <p class="profile-note">{{ 'PROFILE.UPDATE_HINT' | translate }}</p>

        <div class="profile-alert">
          <img src="assets/triangle-exclamation.svg" />
          <div><b>{{ 'PROFILE.PHONE_EMAIL_WARNING_BOLD' | translate }}</b>{{ 'PROFILE.PHONE_EMAIL_WARNING' | translate }}</div>
        </div>

        <div class="profile-actions"
             [class.profile-actions--between]="!(this.currentUser.email == null || this.currentUser.email_confirmado || this.currentUser.email_confirmado == null)">
          <button *ngIf="!this.currentUser.email_confirmado && this.currentUser.email_confirmado != null && this.currentUser.email != null"
                  type="button" class="fb-btn fb-btn--ghost" (click)="reenviarCorreo()"
                  [disabled]="blockEnvioCorreo ? 'true' : null">{{ 'PROFILE.RESEND_EMAIL' | translate }}</button>

          <button type="submit" class="fb-btn fb-btn--primary" [attr.disabled]="update ? '' : null">
            {{ 'PROFILE.UPDATE_BTN' | translate }}
          </button>
        </div>
      </form>

    </div>

    <ng-template #loggedOut>{{ 'PROFILE.LOG_IN' | translate }}</ng-template>
  </div>
</div>
